module.exports = "h2.text-center {\n    font-size: 2.2em;\n    text-transform: uppercase;\n    font-weight: 900;\n    letter-spacing: 1px;\n}"